// Entry is chosen by the build mode (`electron.admin`, `web.admin`, ...), not by env
const role = __APP_ROLE__

const entryMap: Record<
  'admin' | 'user',
  () => Promise<{ default?: () => void }>
> = {
  //@ts-ignore
  admin: () => import('./main.admin'),
  //@ts-ignore
  user: () => import('./main.user'),
}

const loadEntry = entryMap[role]

if (!loadEntry) {
  throw new Error(`Unknown app role: ${role}`)
}

// Entry modules render on import; an optional default export is a bootstrap hook
loadEntry().then((module) => {
  if (typeof module.default === 'function') {
    module.default()
  }
})
